import * as c from './constants';
import axios from 'axios';

export const setQuoteFlowData = (quoteFlowData) => {
  return Promise.resolve({
    type: c.SET_QUOTEFLOW_DATA,
    payload: quoteFlowData
  });
}

export const setCompletedSteps = (completedSteps, activeSteps) => {
  return Promise.resolve({
    type: c.SET_COMPLETE_STEPS,
    completedSteps,
    activeSteps
  });
}

export const postData = (params, url, paramThatChanged) => {
  return (dispatch) => {
    return axios.post(url, params, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      if (paramThatChanged !== "destinationCity" && paramThatChanged !== "originCity") {
        if ((!params.destinationCity || paramThatChanged === 'destinationZipCode') && params.destinationZipCode) {
          dispatch(addAddressOptions("destinationCity", response.data.Destination && response.data.Destination.Value ? response.data.Destination.Value : []));
        }
        if ((!params.originCity || paramThatChanged === 'originZipCode') && params.originZipCode) {
          dispatch(addAddressOptions("originCity", response.data.Origin && response.data.Origin.Value ? response.data.Origin.Value : []));
        }
      }

      return response;
    });
  };
}

export const getBookingFlowSettings = () => {
  return dispatch =>
    axios.get('/api/PODS/BookingFlowSettingsWebService')
      .then((response) => {
        dispatch({ type: c.GET_BOOKING_FLOW_SETTINGS, index: 1 });
        return response;
      });
}

export const postSalesforceLeadData = (customerType, quoteData) => {
  if (quoteData.destinationZipCode == null) {
    quoteData.destinationZipCode = quoteData.originZipCode;
    quoteData.destinationCity = quoteData.originCity;
  }
  var endpoint = '';
  if (customerType == 'residential') {
    endpoint = '/api/PODS/Salesforce/SendResidentialQuote';
  }
  else {
    endpoint = '/api/PODS/Salesforce/SendCommercialQuote';
  }
  return dispatch =>
    axios.post(endpoint, quoteData)
      .then((response) => {
        dispatch({ type: c.POST_SALESFORCE_LEAD_DATA, index: 1 });
        return response;
      });
}

export const addAddressOptions = (addressName, addressOptions, skipAddressProcessing = false) => {
  return {
    type: c.SET_ADDRESS_OPTIONS,
    addressName,
    addressOptions,
    skipAddressProcessing
  }
}

export const setAvailabilityDates = (availabilityDates) => {
  return Promise.resolve({
    type: c.SET_AVAILABILITY_DATES,
    availabilityDates
  });
}

export const setErrorModal = (errorModal) => {
  return Promise.resolve({
    type: c.SET_ERROR_MODAL,
    errorModal
  });
}